import CONVERSATIONS from 'consts/conversations.consts';
import { DateTime } from "luxon";

export function getConversationType(type) {
  return CONVERSATIONS.TYPES[type] ?? 'Desconocido';
}

export function isUnattended(conversation, { now = DateTime.now(), maxTime = 300 } = {}) {
  if (!conversation) return null;
  if (!conversation.lastMessageWasSentByContact) return null;
  if (!conversation.lastMessageSentAt) return null;

  const lastMessageSentAt = DateTime.fromISO(conversation.lastMessageSentAt);
  const diff = now.diff(lastMessageSentAt);

  const times = {
    days: diff.as("days"),
    hours: diff.as("hours"),
    minutes: diff.as("minutes"),
    seconds: diff.as("seconds"),
  };

  if (times.seconds < maxTime) {
    return null;
  }
  
  return times;
}

export function getUnattendedLabel(conversation, { now = DateTime.now(), maxTime = 300 } = {}) {
  const diff = isUnattended(conversation, { now, maxTime });

  if (!diff) return null;

  // Entre 5 minutos y menos de 1 día
  if (diff.days < 1) {
    const seconds = Math.floor(diff.seconds);

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    if (h > 0) {
      return `${h}h ${m}m ${s}s`;
    }

    return `${m}m ${s}s`;
  }

  // Entre 1 y 2 días
  if (diff.days >= 1 && diff.days < 2) {
    return "Ayer";
  }

  // Más de 2 días
  const lastMessageSentAt = DateTime.fromISO(conversation.lastMessageSentAt);
  return lastMessageSentAt.toFormat("dd-MM-yyyy");
}